import(/* webpackMode: "eager" */ "/app/app/articles/diving-trips-in-fiji-the-ultimate-pre-travel-guide-for-scuba-lovers/page.tsx");
